import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDashboardData } from '../../../store/dashboard/action';
import Welcome from './Welcome';
import SourceTypeDist from './SourceTypeDist';
import VendorCP from './VendorCP';
import MasterProjectUploads from './MasterProjectUploads';
import UserOnboarding from './UserOnboarding';
import UploadsByProject from './UploadsByProject';
import UploadsOverTime from './UploadsOverTime';

// const uploadByProjectData = [
//   { name: 'Project A', uploads: 240 },
//   { name: 'Project B', uploads: 180 },
//   { name: 'Project C', uploads: 100 },
// ];

// const sourceTypeData = [
//   { name: 'Procured Data', value: 300 },
//   { name: 'Channel Partner', value: 200 },
// ];

// const uploadsOverTimeData = [
//   { date: 'Apr 1', uploads: 40 },
//   { date: 'Apr 2', uploads: 80 },
//   { date: 'Apr 3', uploads: 65 },
//   { date: 'Apr 4', uploads: 100 },
//   { date: 'Apr 5', uploads: 120 },
// ];

// const vendorVsChannelData = [
//   { name: 'Vendor Uploads', value: 320 },
//   { name: 'Channel Partner Uploads', value: 200 },
// ];

// const projectUploadVolume = [
//   { project: 'Master Project 1', count: 130 },
//   { project: 'Master Project 2', count: 220 },
//   { project: 'Master Project 3', count: 160 },
// ];


const Dashboard = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchDashboardData({ timerange: '90days' }));
    }, [dispatch]);

    const {
        uploadByProjectData = [],
        sourceTypeData = [],
        uploadsOverTimeData = [],
        vendorVsChannelData = [],
        projectUploadVolume = [],
        userOnboardingData = [],
    } = useSelector((state) => state.Dashboard.dashboardData);
    
   const { loading } = useSelector((state) => state.Dashboard);
   if (loading) {
        return (
            <div className="flex items-center justify-center h-screen">
                <h1 className="text-2xl font-bold text-gray-500">Loading...</h1>
            </div>
        );
    }

    // if (uploadByProjectData.length===0 || 
    //     sourceTypeData.length===0 || 
    //     uploadsOverTimeData.length===0 || 
    //     vendorVsChannelData.length===0 || 
    //     projectUploadVolume.length===0 || 
    //     userOnboardingData.length===0) 
    // {
    //     return (
    //         <NoData />
    //     );
    // }

    return (
        <div className="p-4 space-y-6">
            {/* Welcome Section */}
            <Welcome />

            {/* Charts Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {/* Uploads by Project */}
                <UploadsByProject data={uploadByProjectData} />

                {/* Source Type Distribution */}
                <SourceTypeDist data={sourceTypeData} />

                {/* Vendor vs Channel Partner */}
                <VendorCP data={vendorVsChannelData}/>

                {/* Uploads Over Time */}
                <UploadsOverTime data={uploadsOverTimeData} />

                {/* Master Project Upload Volumes */}
                <MasterProjectUploads data={projectUploadVolume} />

                {/* User Onboarding Stats */}
                <UserOnboarding data={userOnboardingData} />

            </div>
        </div>
    );
};

export default Dashboard;